import { GET_OFFERS_ERROR, GET_OFFERS_START, GET_OFFERS_SUCCESS } from "../../types";

export default function offers(state, action) {
  switch (action.type) {
    case GET_OFFERS_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case GET_OFFERS_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case GET_OFFERS_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return { ...state };
  }
}
